import React, { useState, useEffect } from 'react';
import {
  Box, Button, InputBase, Typography, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, ThemeProvider,
  Tooltip,
} from '@mui/material';
import axios, { AxiosResponse } from 'axios';
import BasicTable, { Column } from '../../components/table';
import { DailyLogfields } from '../../constants/Dailylogfields';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { useNavigate } from 'react-router-dom';
import { BASEURL } from "../../constants/Common"
import getTheme from '../../theme/theme';
import FloatingButton from '../../pages/usersupport/helpdesk/FloatingButton';
import { OrganizationFinal } from '../../pages/subscriptionplans/Subscription';

export interface DailyLog {
  id: number | null;
  assignedto: string;
  createddate: string;
  projectcode: string;
  status: string;
  title: string;
  description: string;
  projectname: string;
  createdby: string;
  remarks: string;
  attachments: File | null;
  attachments2: File | null;
  attachments3: File | null;
  attachments4: File | null;
  attachments5: File | null;
  attachments6: File | null;
  //  attachments: File[];
  project_id: string;
  signature: string;
  initials: string;
}

interface ProjectNames {
  id: number;
  project_name: string;
}


interface DailyLogsPageProps {
  selectedProject: string; // Define the selectedProject prop
}

const DailyLogsPage: React.FC<{ projectNameList: ProjectNames[] }> = ({ projectNameList }) => {
  //  const [titles, setTitles] = useState<string[]>([]); // State to hold titles
  const [dailyLogs, setDailyLogs] = useState<DailyLog[]>([]);
  const [filteredLogs, setFilteredLogs] = useState<DailyLog[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  const [newLog, setNewLog] = useState<DailyLog>({
    id: null,
    assignedto: '',
    createddate: '',
    projectcode: '',
    status: '',
    title: '',
    description: '',
    createdby: '',
    remarks: '',
    projectname: '',
    attachments: null,
    attachments2: null,
    attachments3: null,
    attachments4: null,
    attachments5: null,
    attachments6: null,
    project_id: '',
    signature: '',
    initials: '',
  });
  const [selectedLog, setSelectedLog] = useState<DailyLog | null>(null);
  const [editMode, setEditMode] = useState<boolean>(false); // State to track edit mode
  //const [selectedProjectTitle, setSelectedProjectTitle] = useState<string>('');
  const navigate = useNavigate();
  // const selectedProject = useSelector((state: RootState) => state.project.selectedProject);
  const selectedProjectTitle = useSelector((state: RootState) => state.project.selectedProjectTitle);
  const [projectNamesData, setProjectNamesData] = useState<ProjectNames[]>([]);
  const orgid = localStorage.getItem('orgid');
  const userid = localStorage.getItem('authData');
  const [organizationFinal, setOrganizationFinal] = useState<OrganizationFinal | null>(null);



  const userraccess = JSON.parse("" + localStorage.getItem('userrole'));
  const moduleAccess = userraccess?.modulesaccess;


  // Filter rows based on selectedProject
  const filteredRows = filteredLogs.filter((log) =>
    selectedProjectTitle ? log.project_id === selectedProjectTitle : true
  );

  useEffect(() => {
    const fetchDailyLogs = async () => {
      try {
        //const url = BASEURL + '/dailylogs/';
        const url = `${BASEURL}/dailylogs/?orgid=${orgid}&userid=${userid}`
        const response = await axios.get(url, {
          headers: { Accept: 'application/json', },
        });

        setDailyLogs(response.data.dailylogs);

        // dispatch(setLogs(response.data.daily_logs));
      } catch (error) {
        console.log(error);
      }
    };
    fetchDailyLogs();
    setProjectNamesData(projectNameList)
    fetchOrganization();

  }, []);

  useEffect(() => {
    // Filter logs based on title when search term changes
    if (selectedProjectTitle == '0') {
      setFilteredLogs(dailyLogs.filter((log) => (log.project_id !== selectedProjectTitle)));
    }
    else {
      setFilteredLogs(dailyLogs.filter((log) => (log.project_id === selectedProjectTitle)));
    }
  }, [dailyLogs, searchTerm, selectedProjectTitle]);

  useEffect(() => {
    // Filter logs based on title when search term changes
    setFilteredLogs(
      dailyLogs.filter((log) =>
        log.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        log.assignedto.toLowerCase().includes(searchTerm.toLowerCase()) ||
        log.projectname.toLowerCase().includes(searchTerm.toLowerCase()) ||
        log.status.toLowerCase().includes(searchTerm.toLowerCase()) ||
        log.createddate.toLowerCase().includes(searchTerm.toLowerCase()) ||
        log.projectcode.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [dailyLogs, searchTerm]);

  const fetchOrganization = async () => {
    try {
      const response = await axios.get(`${BASEURL}/organization/${orgid}/`, {
        headers: { Accept: 'application/json' },
      });
      setOrganizationFinal(response.data);
      const subscriptionStatus = response.data.organization?.organization_subscription_status;
      localStorage.setItem('subscriptionstatus', subscriptionStatus)
    } catch (error) {
      console.error('Error fetching organization:', error);
    }
  };

  const columns: Column[] = [
    { id: 'projectcode', label: 'Project Code', align: 'left' },
    { id: 'projectname', label: 'Project Name', align: 'left' },
    { id: 'title', label: 'Title', align: 'left' },
    { id: 'status', label: 'Status', align: 'left' },
    { id: 'assignedto', label: 'Assigned To', align: 'left' },
    { id: 'createddate', label: 'Created Date', align: 'left' },
    { id: 'action', label: '', align: 'left' },
  ];

  const handleSearch = () => {
    // Handle search logic
    console.log('Searching...');
  };

  const handleClearSearch = () => {
    setSearchTerm('');
  };

  const rows = filteredLogs.map((log, index) => ({
    id: index + 1,
    projectcode: log.projectcode,
    projectname: log.projectname,
    title: log.title,
    status: log.status,
    assignedto: log.assignedto,
    createddate: log.createddate,
    action: (
      <Button variant='contained' onClick={() => handleViewLog(log)}>
        {editMode ? 'View' : 'View'}
      </Button>
    ),
  }));

  const handleCreateNew = () => {

    //navigate('/createnewdailylog');
    navigate('/createnewdailylog', { state: { projectNameList: projectNameList } });
  };

  const handlePopupClose = () => {
    setOpenPopup(false);
    setEditMode(false);
  };

  const handleViewLog = (log: DailyLog) => {
    setSelectedLog(log);
    // Navigate to editlog page to display the selected log details
    //navigate('/log-details');
    navigate('/log-details', { state: { logDetails: log, projectNamesData: projectNamesData } });


  };


  const handleFormChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    if (selectedLog) {
      setSelectedLog((prevLog) => ({
        ...prevLog!,
        [name]: value,
      }));
    } else {
      setNewLog((prevLog) => ({
        ...prevLog!,
        [name]: value,
      }));
    }
  };

  const handleBack = () => {
    setEditMode((prevEditMode) => !prevEditMode); // Toggle edit mode
  }; // Enable fields for editing

  const handleFormSubmit = async () => {
    try {
      // let response;
      let response: AxiosResponse<DailyLog>;

      if (selectedLog && selectedLog.id !== null) {
        // If a log is selected, update the log using its ID

        response = await axios.put(
          BASEURL + `/dailylogs/${selectedLog.id}/`,
          selectedLog,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
      } else {
        // If no log is selected, make a POST request to create a new log

        response = await axios.post(
          BASEURL + '/dailylogs/create/',
          newLog,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
      }

      if (!selectedLog || selectedLog.id === null) {
        // If no log is selected or log is newly created, add the new log to the dailyLogs state
        setDailyLogs((prevLogs) => [...prevLogs, response.data]);
        setOpenPopup(false); // Close the popup
      } else if (editMode) {
        // If in edit mode, update the selected log in the dailyLogs state
        setDailyLogs((prevLogs) =>
          prevLogs.map((log) =>
            log.id === response.data.id ? response.data : log
          )
        );
        setOpenPopup(true); // Open popup with edited data
        setSelectedLog(response.data); // Set selectedLog to the edited log
        setEditMode(false); // Switch to read mode
      }
      setNewLog({
        ...newLog,
        id: response.data.id,
      });

      // Refetch the daily logs after updating
    } catch (error) {
      console.error('Error submitting:', error);
    }
  };
  const subscriptionstatus = organizationFinal?.organization?.organization_subscription_status;

  return (
    <ThemeProvider theme={getTheme()}>
      {(subscriptionstatus === 'Active' || subscriptionstatus === 'Expired') ? (
        <Box sx={{ marginTop: '-60px' }}>
          {subscriptionstatus === 'Expired' && (
            <Typography variant="body1" >
              <h3>Please renew your subscription.</h3>
            </Typography>
          )}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant='h5' component='div'>
              Daily Logs
            </Typography>
            <Box sx={{ marginLeft: 'auto' }}>
              <Tooltip
                title={
                  moduleAccess === 'Owner' && subscriptionstatus === 'Active'
                    ? ''
                    : 'You do not have access to create a new feature'
                }
                placement="top"
                arrow
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    if (moduleAccess === 'Owner' && subscriptionstatus === 'Active') {
                      handleCreateNew();
                    }
                  }}
                  sx={{
                    mr: 1,
                    opacity: moduleAccess !== 'Owner' || subscriptionstatus !== 'Active' ? 0.5 : 1
                  }}
                >
                  Create New
                </Button>
              </Tooltip>
            </Box>
          </Box>

          <Box sx={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
            <InputBase
              placeholder='Search…'
              inputProps={{ 'aria-label': 'search' }}
              sx={{
                marginRight: '10px',
                border: '1px solid',
                borderRadius: '4px',
                paddingLeft: '10px',
                ml: '5%',
                height: '45px'
              }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Button variant='contained' onClick={handleSearch}>
              Search
            </Button>
          </Box>

          <Box sx={{ marginTop: '20px' }}>
            <BasicTable columns={columns} rows={rows} />
          </Box>

          <Dialog open={openPopup} onClose={handlePopupClose}>
            <DialogTitle>
              {selectedLog ? 'View Daily Log' : 'Create New Daily Log'}
              <IconButton
                aria-label='close'
                onClick={handlePopupClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              {DailyLogfields.map((field) => (
                <TextField
                  key={field.name}
                  fullWidth
                  margin='normal'
                  label={field.title}
                  name={field.name}
                  type={field.type}
                  value={
                    selectedLog
                      ? selectedLog[field.name as keyof DailyLog]
                      : newLog[field.name]
                  }
                  onChange={(e) => handleFormChange(e)}
                  disabled={!editMode} // Disable fields when not in edit mode
                  required={field.isRequired}
                />
              ))}

            </DialogContent>
            <DialogActions>
              <Button variant='contained'
                onClick={editMode ? handleBack : handlePopupClose}
                color='primary'>
                Cancel
              </Button>
              {selectedLog ? (
                <Button onClick={editMode ? handleBack : handlePopupClose}
                  color='primary'>
                  Cancel
                </Button>

              ) : (<Button onClick={handlePopupClose} color='primary'>
                Cancel
              </Button>
              )}
              {selectedLog && (
                <>
                  {!editMode && (
                    <Button onClick={() => setEditMode(true)} color='primary'>
                      Edit
                    </Button>
                  )}
                  {editMode && (
                    <>
                      {/* <Button onClick={handleBack} color='primary'>
                      Back
                    </Button> */}
                      <Button onClick={handleFormSubmit} color='primary'>
                        Submit
                      </Button>
                    </>
                  )}
                </>
              )}
              {!selectedLog && (
                <Button onClick={handleFormSubmit} color='primary'>
                  Save
                </Button>
              )}
            </DialogActions>
          </Dialog>
          <FloatingButton />
        </Box>
      ) : (subscriptionstatus === '' &&
        <Typography variant="body1">
          <h3>Please purchase a subscription plan.</h3>
        </Typography>
      )}
    </ThemeProvider>
  );
};
export default DailyLogsPage;